import { observable, action } from 'mobx'
import Api from '@api/live'
import investModal from '../InvestModal'

export default class {
  constructor(form) {
    this.form = form
  }

  @observable live_info = {}

  @action
  getLivePopInfo = async (id, start_time) => {
    const { success, data } = await Api.livePopInfo({ id, start_time })
    if (success) {
      this.live_info = data
      this.form.setFieldsValue({
        extensionBanner: data.extensionBanner,
        liveType: +data.liveType ? +data.liveType : 1,
        popTime: +data.popTime ? 0 : 45
      })
    }
  }

  setLivePopTime = async (params, onOk) => {
    const { success, data, RetCode } = await Api.livePopTime(params)
    if (RetCode == 1000) {
      investModal()
      return
    }
    if (success) {
      onOk(params, data)
    }
  }
}
